export default __webpack_public_path__ + "static/media/about-grid-02.695487e1.jpg";